export const DEVELOPER_EXAMPLE_INSTALL_SNIPPET =
  `<script src="https://t.atrium.run/a.js" data-workspace="00000000-0000-0000-0000-000000000001" async></script>`

export type ExampleContainerPayload = {
  container: {
    id: string
    brand_kit_id: string
    workspace_id: string
    published_version: number
    draft_version: number
    published_at: string | null
    updated_at: string
  }
  tags: Array<{
    id: string
    container_id: string
    name: string
    type: string
    config: Record<string, unknown>
    trigger_ids: string[]
    priority: number
    enabled: boolean
    consent_category: string
    rate_limit_exempt: boolean
  }>
  triggers: Array<{
    id: string
    container_id: string
    name: string
    type: string
    config: Record<string, unknown>
    created_at: string
  }>
  variables: Array<{
    id: string
    container_id: string
    name: string
    type: string
    config: Record<string, unknown>
    created_at: string
  }>
  versions: Array<{
    id: string
    version: number
    notes: string | null
    published_by: string
    created_at: string
  }>
  installSnippet: string
}

const CONTAINER_ID = 'example-container'
const WORKSPACE_ID = '00000000-0000-0000-0000-000000000001'

export function getDeveloperExampleContainerPayload(): ExampleContainerPayload {
  const now = new Date().toISOString()
  const triggerPageview = {
    id: 'example-trigger-pageview',
    container_id: CONTAINER_ID,
    name: 'All pages',
    type: 'pageview',
    config: {},
    created_at: now,
  }
  const triggerLead = {
    id: 'example-trigger-lead',
    container_id: CONTAINER_ID,
    name: 'Thank you page',
    type: 'pageview',
    config: { path: '/thank-you' },
    created_at: now,
  }

  return {
    container: {
      id: CONTAINER_ID,
      brand_kit_id: '',
      workspace_id: WORKSPACE_ID,
      published_version: 3,
      draft_version: 4,
      published_at: now,
      updated_at: now,
    },
    tags: [
      {
        id: 'example-tag-base',
        container_id: CONTAINER_ID,
        name: 'Atrium Base Pixel',
        type: 'builtin',
        config: { tracker: 'universal_ads' },
        trigger_ids: [triggerPageview.id],
        priority: 0,
        enabled: true,
        consent_category: 'necessary',
        rate_limit_exempt: false,
      },
      {
        id: 'example-tag-lead',
        container_id: CONTAINER_ID,
        name: 'Conversion — Lead',
        type: 'pixel',
        config: { url: 'https://t.atrium.run/pixel?event=lead' },
        trigger_ids: [triggerLead.id],
        priority: 1,
        enabled: true,
        consent_category: 'analytics',
        rate_limit_exempt: false,
      },
    ],
    triggers: [triggerPageview, triggerLead],
    variables: [
      {
        id: 'example-var-domain',
        container_id: CONTAINER_ID,
        name: 'page_hostname',
        type: 'javascript',
        config: { expression: 'window.location.hostname' },
        created_at: now,
      },
    ],
    versions: [
      {
        id: 'example-version-3',
        version: 3,
        notes: 'Published base pixel + lead conversion',
        published_by: 'example',
        created_at: now,
      },
    ],
    installSnippet: DEVELOPER_EXAMPLE_INSTALL_SNIPPET,
  }
}

export const DEVELOPER_EXAMPLE_CONTAINER = {
  containerId: CONTAINER_ID,
  displayName: 'HVACDirect',
}

export const DEVELOPER_EXAMPLE_INSTALL_STATUS_URL = '/api/developer/example/container/install-status'
